import { PaymentMode } from 'UI/constants/entityTypes';

import { FormFieldsMap } from '../fields';
import { flattenSplits, getFilesThatChanged } from '../utils';

const getOptionId = value => {
  if (value === null || typeof value === 'undefined') return value;
  return typeof value === 'object' ? value.id : value;
};

export const buildPlacementUpdatePayload = ({
  assignmentDataSheet,
  candidateDataSheet,
  fileCategories = [],
  files = [],
  formData,
  splits = []
}) => {
  const finalSplits = flattenSplits(splits, formData);
  const filesThatChanged = getFilesThatChanged(fileCategories, files, formData);
  const paymentTermsId = getOptionId(formData.payment_terms_id);
  const {
    candidateSourceType,
    jobOrderSourceType,
    billToCompany,
    hiringAuthority,
    [FormFieldsMap.ShouldRequestFeeChange.key]: requestedFeeChange,
    [FormFieldsMap.ShouldRequestGuaranteePeriodChange.key]: requestedGuaranteeDaysChange,
    [FormFieldsMap.ReasonForRequestChange.key]: reasonForChange
  } = formData;

  return {
    ...formData,
    splits: finalSplits,
    files: filesThatChanged,
    fee_amount: Number.parseFloat(formData.fee_amount),
    fee_percentage:
      formData.fee_agreement_payment_scheme_id !== PaymentMode.Flat
        ? formData.fee_percentage
        : null,
    source_type_id: getOptionId(candidateSourceType),
    job_order_source_type_id: getOptionId(jobOrderSourceType),
    payment_terms_id: paymentTermsId,
    billingCompanyId: getOptionId(billToCompany),
    hiringAuthorityId: getOptionId(hiringAuthority),
    assignmentDataSheetId: getOptionId(assignmentDataSheet),
    candidateDataSheetId: getOptionId(candidateDataSheet),
    requestedFeeChange,
    requestedGuaranteeDaysChange,
    reasonForChange: requestedFeeChange || requestedGuaranteeDaysChange ? reasonForChange : null
  };
};
